import { render } from "./index.vue?vue&type=template&id=1c4c4f4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1c4c4f4c&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=1c4c4f4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4c4f4c"]])

export default __exports__